var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowershell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004aad",
    d: "M 290.472656 327.742188 L 24.160156 327.742188 C 16.738281 327.742188 9.984375 324.605469 5.65625 319.144531 C 1.265625 313.628906 -0.257812 306.21875 1.464844 298.871094 L 54.910156 69.4375 C 57.988281 56.160156 70.992188 45.730469 84.527344 45.730469 L 350.839844 45.730469 C 358.261719 45.730469 365.015625 48.871094 369.34375 54.328125 C 373.734375 59.847656 375.257812 67.257812 373.535156 74.605469 L 320.078125 304.039062 C 317.011719 317.316406 304.007812 327.742188 290.472656 327.742188 Z M 84.527344 68.597656 C 81.523438 68.597656 77.894531 71.570312 77.195312 74.605469 L 23.71875 304.039062 L 24.160156 304.878906 L 290.472656 304.878906 C 293.476562 304.878906 297.105469 301.90625 297.804688 298.871094 L 351.265625 69.421875 Z M 84.527344 68.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004aad",
    d: "M 252.285156 285.824219 L 183.6875 285.824219 C 177.378906 285.824219 172.257812 280.703125 172.257812 274.390625 C 172.257812 268.078125 177.378906 262.957031 183.6875 262.957031 L 252.195312 262.957031 C 258.507812 262.957031 263.671875 268.078125 263.671875 274.390625 C 263.671875 280.703125 258.597656 285.824219 252.285156 285.824219 Z M 252.285156 285.824219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#004aad",
    d: "M 76.980469 293.445312 C 73.445312 293.445312 69.96875 291.8125 67.730469 288.71875 C 64.023438 283.613281 65.152344 276.464844 70.257812 272.757812 L 190.425781 185.457031 L 116.796875 106.90625 C 112.484375 102.300781 112.714844 95.078125 117.332031 90.746094 C 121.953125 86.417969 129.160156 86.660156 133.492188 91.265625 L 214.910156 178.140625 C 216.890625 180.257812 217.988281 183.0625 217.988281 185.960938 L 217.988281 187.894531 C 217.988281 191.554688 216.234375 195 213.277344 197.132812 L 83.703125 291.25 C 81.675781 292.730469 79.3125 293.445312 76.980469 293.445312 Z M 76.980469 293.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowershell);
export default __webpack_public_path__ + "static/media/powershell.c2590bbbf509c02410c5c9c9e158471b.svg";
export { ForwardRef as ReactComponent };